import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    favorites: [],
};

const favoritesSlice = createSlice({
    name: 'favorites',
    initialState,
    reducers: {
        toggleFavorite: (state, action) => {
            const { mode, id, data } = action.payload;
            let favoriteData = {...data, ...data.movie_data, ...data.info};
            console.log('added favorite datta', data);
            const existingIndex = state.favorites.findIndex(
                (favorite) => favorite.mode === mode && favorite.id === id
            );

            if (existingIndex !== -1) {
                state.favorites.splice(existingIndex, 1);
            } else {
                state.favorites.push({ mode, id, data: favoriteData });
            }
        },
        clearFavorites: (state) => {
            state.favorites = [];
        },
    },
});

// Export actions
export const { toggleFavorite, clearFavorites } = favoritesSlice.actions;

// Base selector to get all favorites
export const selectFavorites = (state) => state.favorites.favorites || [];

export const selectLive = createSelector(
    [selectFavorites],
    (favorites) => favorites.filter((favorite) => favorite.mode === 'live')
);

// Selector to filter movies
export const selectMovies = createSelector(
    [selectFavorites],
    (favorites) => favorites.filter((favorite) => favorite.mode === 'movie')
);

// Selector to filter series
export const selectSeries = createSelector(
    [selectFavorites],
    (favorites) => favorites.filter((favorite) => favorite.mode === 'series')
);

// Memoized selector to check if an item is favorited
export const selectIsFavorite = (mode, id) =>
    createSelector(
        [selectFavorites],
        (favorites) => favorites.some((favorite) => favorite.mode === mode && favorite.id === id)
    );

export default favoritesSlice.reducer;
